/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bus_medium'
export default icon
